export default {
    NavbarLinkText: {
        Text1: "Home",
        Text2: "Deals",
        Text3: "Blog",
    },
    NavbarButtonLogAndReq: {
        Button1: "Cart Information",
        Button2: "Login"
    },
    TitleSectionVenueSearch: "Meeting venues search results",
    Thumbnail: {
        text1: "Meeting Room",
        text2: "Maximum",
        text3: "Accommodation"
    },
    ButtonThumbnail: {
        Text1: "collect",
        Text2: "detail"
    },
    ButtonMore: "Open More",
    PanelHeadingBlog: {
        heading1: "Popular Post",
        heading2: "Recent Post",
        heading3: "Blog Archives"
    },
    NavLeftEvent: {
        Text1: 'Hotel Overview',
        Text2: 'Detail Information',
        Text3: 'Function space & Layouts',
        Text4: 'Accomodation'
    },
    NavLeftMyAccount: {
        Text1: "My Account",
        Text2: "My History RFP",
        Text3: "Billing Info",
        Text4: "Contact",
        Text5: "My History GTS"
    },
    TitleFormHome: 'Search unique venues, compare prices<br /> and book, now',
    TitleRangeFormHome1: 'Pricing Meeting Room',
    TitleRangeFormHome2: 'Pricing Meeting Room',
    TitleFaqPage: 'FAQ',
    ModalLoginText: {
        Text1: 'Welcome to',
        Text2: 'Log in',
        Text3: "Don't have an account?"
    },
    ModalRegisterText: {
        Text1: 'Welcome to',
        Text2: 'Register',
        Text3: "By Clicking Register, you agree to<br />HNS small group meeting"
    },
    DropdownAccount: {
        Text1: "My RFP",
        Text2: "Account",
        Text3: "Share",
        Text4: "Help Center",
        Text5: "Sign Out"
    },
    LastNews: {
        TextTitle: 'Last News'
    },
    FaqSection: {
        TextTitle: 'Frequently asked questions'
    },
    PrivacyContactus: {
        TextTitle1: "Privacy Statement",
        TextTitle2: "Contacting Us",
    },
    TermOfUse: {
        TextTitle1: "Term of use"
    }
}